import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VincularCanceladoPage from './vincular-cancelado.page';
import * as commonActions from '../common.action';
import WebapiCommon from '../util/webapi.common';
import { acessoPermitido } from '../../../acessos.seguranca';

class VincularCanceladoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detalhes: props.detalhes,
      exames: [],
    };
  }

  componentDidMount() {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.getExamesCancelados(
      this.state.detalhes.prontuario,
      this.state.detalhes.laudo
    ).then((exames) => {
      if (exames) {
        var exs = [];

        exames.forEach((ex) => {
          ex.vinculado = ex.vinculado === 'S' ? true : false;
          var d = new Date(ex.data);
          ex.data =
            ('00' + (d.getMonth() + 1)).slice(-2) +
            '/' +
            ('00' + d.getDate()).slice(-2) +
            '/' +
            d.getFullYear() +
            ' ' +
            ('00' + d.getHours()).slice(-2) +
            ':' +
            ('00' + d.getMinutes()).slice(-2) +
            ':' +
            ('00' + d.getSeconds()).slice(-2) +
            'hrs';
          exs.push(ex);
        });

        this.setState({
          exames: exs,
        });
        this.props.commonActions.showFadeCarregando(false);
      }
    });
  }
  render() {
    return (
      <VincularCanceladoPage
        usuario={this.props.usuario}
        exames={this.state.exames}
        acessoPermitido={acessoPermitido}
        altura={this.props.altura}
        exameEntregue={this.props.exameEntregue}
        vincularExame={this.vincularExame.bind(this)}
      />
    );
  }

  vincularExame(checked, laudo) {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.vincularLaudoCancelado(
      this.state.detalhes.laudo,
      laudo,
      checked
    ).then((result) => {
      if (!result.error) {
        var detalhes = this.props.detalhes;

        if (checked) {
          detalhes.qtdCancelados += 1;
        } else {
          detalhes.qtdCancelados -= 1;
        }

        var exames = this.state.exames.map((ex) => {
          if (ex.laudo === laudo) ex.vinculado = checked;
          return ex;
        });
        this.setState({
          exames,
        });
        this.props.commonActions.atualizarDetalhes(detalhes);
        this.props.commonActions.showFadeCarregando(false);
      } else {
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'error',
          'Erro ao vincular ou desvincular o laudo',
          2500
        );
      }
    });
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
    exameEntregue: state.commonReducer.exameEntregue,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VincularCanceladoContainer);



// WEBPACK FOOTER //
// ./src/app/common/vincularCancelado/vincular-cancelado.container.js